import type { ProjectType } from '@atlassian/jira-common-constants/src/index.tsx';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';

export const isJiraSoftware = (projectType: ProjectType | undefined) =>
	projectType && projectType === SOFTWARE_PROJECT;
